import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { UsersListPage } from '@/pages/users/users-list-page';

/** URL-synced filters — a filtered list is shareable / survives reload. */
const SearchSchema = z.object({
  q: z.string().max(200).optional().catch(undefined),
  filter: z.enum(['banned', 'admins']).optional().catch(undefined),
  offset: z.coerce.number().int().min(0).optional().catch(undefined),
});
export type UsersSearch = z.infer<typeof SearchSchema>;

export const Route = createFileRoute('/users/')({
  component: UsersListPage,
  validateSearch: (s) => SearchSchema.parse(s),
});
